import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ROUTE_NAME from '../routes/RouteName';
import HeaderBackground from './nav/HeaderBackground';
import Navbar from './nav/Navbar';
import Sidebar from './nav/Sidebar';

const isPublicRoute = (pathname) => {
	const publicRoutes = [
		ROUTE_NAME.HOME,
		ROUTE_NAME.TWO_FACTOR_AUTH,
		ROUTE_NAME.REGISTRATION,
		ROUTE_NAME.REGISTRATION_DETAILS,
		ROUTE_NAME.FORGOT_PASSWORD,
		ROUTE_NAME.RESET_PASSWORD,
		ROUTE_NAME.LOGOUT,
		ROUTE_NAME.REGISTRATION_COMPLETED,
	];

	const isPrefixMatch = publicRoutes.some(route => {
		if (route === '/') {
			return pathname === '/';
		}
		return pathname.startsWith(route);
	});

	if (isPrefixMatch) {
		return true;
	}

	return false;
};


const Layout = () => {
	const location = useLocation();

	const [isSidebarShow, setIsSidebarShow] = useState(false);

	const toggleSidebar = () => {
		setIsSidebarShow(!isSidebarShow);
	}

	if (isPublicRoute(location.pathname)) {
		return null;
	}

	return (
		<div className="layout layout--top-navigation">
			<Navbar toggleSidebar={toggleSidebar} />
			<Sidebar
				isSidebarShow={isSidebarShow}
				toggleSidebar={toggleSidebar}
			/>
			<div className="margin-top-60">
				<HeaderBackground />
			</div>
		</div>
	);
};

export default Layout;
